import { http, type HttpClient } from './core/http-client';
import type { ModerationCase } from './models';

// Platform staff only; not tenant-scoped.
export class AdminService {
  constructor(private readonly http: HttpClient) {}

  cases = (status?: string) =>
    this.http.get<ModerationCase[]>('/admin/moderation/cases', { query: { status } });

  moderate = (reviewId: string, action: string, reason: string) =>
    this.http.post(`/admin/reviews/${reviewId}/moderate`, { action, reason });
}

export const adminService = new AdminService(http);
